import { useSelector } from 'react-redux';
import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { selectChangePlan } from '@app/redux/changePlan';

import LeaseFeeOptions from '../LeaseFeeOptions';
import OrderDetailsSection from '../OrderDetailsSection';

const EquipmentLeaseFee = ({ priceCurrency }: { priceCurrency: string }) => {
  const { t } = useTranslation('ChangePlan', {
    keyPrefix: 'orderReview.satelliteMigrationDetails.equipmentAndLeaseFee',
  });

  const {
    cart: {
      cartItems: { plan },
    },
  } = useSelector(selectChangePlan);

  const hasLeaseFee = plan?.leaseFeePrice && plan?.leaseFeeShortName;

  return (
    <OrderDetailsSection id="equipment-lease-fee" title={t('title')}>
      <Txt variant="bodySmallRegular">
        {t('installationDetails')}
        <Txt component="span" color="success" variant="bodySmallBold">
          {t('installationDetailsFee')}{' '}
        </Txt>
        {t('furtherInstallationDetails')}
      </Txt>
      {hasLeaseFee && (
        <LeaseFeeOptions
          leaseFeePrice={plan?.leaseFeePrice}
          leaseFeeShortName={plan?.leaseFeeShortName}
          priceCurrency={priceCurrency}
        />
      )}
    </OrderDetailsSection>
  );
};

export default EquipmentLeaseFee;
